import { render, staticRenderFns } from "./DetailTemplate.vue?vue&type=template&id=39451364&scoped=true&"
import script from "./DetailTemplate.vue?vue&type=script&lang=ts&"
export * from "./DetailTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39451364",
  null
  
)

export default component.exports